import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  menulist = [
    {"name":"Horaire"
    },
    {"name":"Bénéficiaires","value":"main"},
    {"name":"Personnel",
      "sub":[
        {"name":"Educateurs"},
        {"name":"Bénévoles"},
        {"name":"Contrats"},
        {"name":"Jours fériés"}
      ]},
    {"name":"Rapport",
      "sub":[
        {"name":"KM","value":"/generate-report-km"},
        {"name":"RA"},
        {"name":"Facturation","value":"/generate-facture"},
        {"name":"Refus"},
        {"name":"Congés et OUT"}
      ]},
    {"name":"Ressources","value":"user-creator"},
  ]
  constructor(private route:Router) { }

  ngOnInit(): void {
  }

}
